"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsetLabel = exports.fieldSetText = exports.input = exports.rightRow = exports.label = exports.optionRow = void 0;
const colors_1 = require("../../helpers/colors");
exports.optionRow = {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 40,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 8,
    paddingBottom: 8,
};
exports.label = {
    width: 220,
    fontSize: 15,
    lineHeight: '40px',
    color: colors_1.LIGHT_TEXT,
    fontFamily: 'sans-serif',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};
exports.rightRow = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignSelf: 'center',
    flex: 1,
};
exports.input = {
    minWidth: 250,
};
exports.fieldSetText = {
    color: colors_1.LIGHT_TEXT,
    fontSize: 14,
    fontFamily: 'monospace',
};
exports.fieldsetLabel = {
    ...exports.fieldSetText,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
};
